import PropTypes from 'prop-types';
import * as S from './styles';

const CheckboxTerm = ({
  id,
  checked,
  onChange,
  children,
  accentColor,
  linkColor,
}) => {
  return (
    <S.CheckboxLabelWrapper htmlFor={id} linkColor={linkColor}>
      <S.CheckboxInput
        id={id}
        checked={checked}
        onChange={onChange}
        accentColor={accentColor}
      />
      {children}
    </S.CheckboxLabelWrapper>
  );
};

CheckboxTerm.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  accentColor: PropTypes.string,
  linkColor: PropTypes.string,
};

CheckboxTerm.defaultProps = {
  accentColor: null,
  linkColor: null,
};

export default CheckboxTerm;
